module.exports = __webpack_public_path__ + "static/img/item_back_bg_white.0bf2c065.svg";